e360.service('userApi', [
   '$http',
   'apiHelper',

   function ($http, apiHelper) {
      return {
         get: function () {
            return apiHelper.get('user');
         },
         update: function (dto) {
            return apiHelper.post('user/update', dto);
         },
         changePassword: function (dto) {
            return apiHelper.post('user/password', dto);
         },
         checkUniqueEmail: function (email, existingId) {
            var uri = 'user/check';
            if (existingId)
               uri += ('/' + existingId);
            uri += ('?email=' + email);
            return apiHelper.get(uri);
         },
         checkUniqueHandle: function (handle, existingId) {
            var uri = 'user/check';
            if (existingId)
               uri += ('/' + existingId);
            uri += ('?handle=' + handle);
            return apiHelper.get(uri);
         }
      };
   }
]);
